import { Module } from 'vuex'

function initialState() {
  return {
    sessionId: '',
  }
}

const sessionModule: Module<any, any> = {
  namespaced: true,

  state: initialState,

  mutations: {
    resetSessionStore(state) {
      const initial: any = initialState()
      Object.keys(initial).forEach((key) => {
        if (key in state) {
          state[key] = initial[key]
        }
      })
    },

    setSessionId(state, sessionId) {
      state.sessionId = sessionId
    },
  },

  actions: {
    resetSessionStore({ commit }) {
      commit('resetSessionStore')
    },

    setSessionId({ commit }, sessionId) {
      commit('setSessionId', sessionId)
    },
  },

  getters: {
    sessionId(state) {
      return state.sessionId
    },
  },
}

export default sessionModule
